import { useEffect, useRef } from 'react';

import type { IRestaurantNode } from 'generated/rbi-graphql';
import { CustomEventNames, EventTypes, useCRMEventsContext } from 'state/crm-events';

const HOURS_RANGE_TO_CHECK = {
  OPEN: 11, // 11:00 am
  CLOSE: 19, // 7:00 pm
};

export const useClosedStoreEvent = ({
  isFirst = false,
  isOpen = false,
  restaurant,
}: {
  isFirst: boolean;
  isOpen: boolean;
  restaurant: IRestaurantNode;
}) => {
  const storeClosedEventEmitted = useRef(false);
  const { logRBIEvent } = useCRMEventsContext();

  useEffect(() => {
    if (!storeClosedEventEmitted.current && isFirst && !isOpen) {
      const currentDateTime = new Date();
      const currentHour = currentDateTime.getHours();

      // It's not likely to have stores closed on this range, so in case that happens we emit the amplitude log.
      if (currentHour >= HOURS_RANGE_TO_CHECK.OPEN && currentHour < HOURS_RANGE_TO_CHECK.CLOSE) {
        storeClosedEventEmitted.current = true;

        logRBIEvent({
          name: CustomEventNames.STORE_CLOSED_ON_OPERATIONAL_HOURS,
          type: EventTypes.Other,
          attributes: {
            storeId: restaurant.storeId ?? '',
            isAvailable: restaurant.isAvailable,
            currentHour,
            dateNow: currentDateTime.toString(),
            dateNowUTC: currentDateTime.toISOString(),
          },
        });
      }
    }
  }, [isFirst, isOpen, logRBIEvent, restaurant]);
};
